"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactI18next = require("react-i18next");
var _definitions = require("@ppay/definitions");
var _TotalAmount = require("./TotalAmount");
var _AmountItem = require("./AmountItem");
var _ui = require("../../../../ui");
var _hooks = require("../../../../../hooks");
var _exchange = require("../../exchange");
var _excluded = ["tooltipServiceName", "balanceName", "children"];
var _templateObject, _fiatFeePercent;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledTotalAmount = (0, _styledComponents.default)(_TotalAmount.TotalAmount)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: 20px 0;\n"])));
var fiatFeePercent = (_fiatFeePercent = {}, _defineProperty(_fiatFeePercent, _definitions.Ticker.UAH, '1.5%'), _defineProperty(_fiatFeePercent, _definitions.Ticker.USD, '1.5%'), _defineProperty(_fiatFeePercent, _definitions.Ticker.EUR, '1.5%'), _fiatFeePercent);
var ServiceFeeTooltipContent = function ServiceFeeTooltipContent(_ref) {
  var serviceName = _ref.serviceName,
    isInternalAddress = _ref.isInternalAddress,
    ticker = _ref.ticker,
    isFiat = _ref.isFiat;
  var _useTranslation = (0, _reactI18next.useTranslation)('libTransfers'),
    t = _useTranslation.t;
  var text = isInternalAddress ? 'internalServiceFeeTooltip' : isFiat ? 'fiatServicesFeeTooltip' : 'serviceFeeTooltip';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, t(text, {
    serviceName: serviceName,
    ticker: ticker,
    fee: fiatFeePercent[ticker]
  }));
};
var Card = function Card(_ref2) {
  var _props$isInternalAddr;
  var tooltipServiceName = _ref2.tooltipServiceName,
    balanceName = _ref2.balanceName,
    children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded);
  var _useTranslation2 = (0, _reactI18next.useTranslation)(['libTransfers', 'libCommon']),
    t = _useTranslation2.t;
  var _useWithdrawContext = (0, _hooks.useWithdrawContext)(),
    amount = _useWithdrawContext.amount,
    fee = _useWithdrawContext.fee,
    fiatTickerAmount = _useWithdrawContext.fiatTickerAmount,
    fiatTickerFee = _useWithdrawContext.fiatTickerFee,
    ticker = _useWithdrawContext.ticker,
    fiatTicker = _useWithdrawContext.fiatTicker,
    balanceAfterTransaction = _useWithdrawContext.balanceAfterTransaction,
    fiatBalanceAfterTransaction = _useWithdrawContext.fiatBalanceAfterTransaction,
    fiatTickerTotal = _useWithdrawContext.fiatTickerTotal,
    total = _useWithdrawContext.total,
    isInternalAddress = _useWithdrawContext.isInternalAddress,
    isFiat = _useWithdrawContext.isFiat,
    mode = _useWithdrawContext.mode;

  // TODO convert already enabled, withdraw context empty (move to separate ctx later)
  if (!mode) return /*#__PURE__*/_react.default.createElement(_exchange.ExchangeTransactionInfoCard, {
    tooltipServiceName: tooltipServiceName,
    balanceName: balanceName
  }, children);
  return /*#__PURE__*/_react.default.createElement(_ui.Card, null, /*#__PURE__*/_react.default.createElement(_ui.CardHeader, null, /*#__PURE__*/_react.default.createElement(_ui.CardTitle, null, t('transactionDetails'))), /*#__PURE__*/_react.default.createElement(_ui.CardBody, {
    className: "pt-0"
  }, /*#__PURE__*/_react.default.createElement(_AmountItem.AmountItem, {
    title: t('amount'),
    ticker: ticker,
    fiatTicker: fiatTicker,
    amount: amount,
    fiatTickerAmount: fiatTickerAmount
  }), /*#__PURE__*/_react.default.createElement(_AmountItem.AmountItem, {
    title: t('serviceFee'),
    tooltip: /*#__PURE__*/_react.default.createElement(ServiceFeeTooltipContent, {
      isInternalAddress: (_props$isInternalAddr = props.isInternalAddress) !== null && _props$isInternalAddr !== void 0 ? _props$isInternalAddr : isInternalAddress,
      isFiat: isFiat,
      serviceName: tooltipServiceName,
      ticker: ticker
    }),
    ticker: ticker,
    fiatTicker: fiatTicker,
    amount: fee,
    fiatTickerAmount: fiatTickerFee,
    className: "mb-0"
  }), /*#__PURE__*/_react.default.createElement(StyledTotalAmount, {
    ticker: ticker,
    amount: total,
    convertedTicker: fiatTicker,
    convertedAmount: fiatTickerTotal
  }), /*#__PURE__*/_react.default.createElement(_AmountItem.AmountItem, {
    title: "".concat(balanceName, " ").concat(t('libCommon:balance').toLowerCase(), " ").concat(t('after'), ":"),
    ticker: ticker,
    fiatTicker: fiatTicker,
    amount: balanceAfterTransaction,
    fiatTickerAmount: fiatBalanceAfterTransaction
  }), children));
};
exports.Card = Card;